import axios from "axios"

const auth = localStorage.getItem("auth_token");
const headers = {
    "x-auth-token": auth,
};

export const getChecklistData = async (project_id, tb_id) => {
    return new Promise((resolve, reject) => {
        axios
            .get(`api/v1/disclouser-checklist/${project_id}/${tb_id}`, { headers })
            .then((res) => {
                return resolve(res);
            })
            .catch((err) => {
                return reject(err);
            });
    });
};
